import { TenantSchema } from "../Tenant";
import { LocationSchema } from "./Location";
import { z } from "zod";

export type GuestDetail = z.infer<typeof GuestDetailSchema>;
export const GuestDetailSchema = z.object({
  id: z.number().optional(),
  code: z.string().optional(),
  location_id: z.number().optional(),
  phone_number: z.string().optional(),
  state: z.string(),
  available_from: z.string(),
  available_to: z.string(),
  conversation_id: z.string(),
  qr: z.string().optional(),
  name: z.string(),
  lang_cd: z.string().optional(),
  tenant: TenantSchema.optional(),
  room_name: LocationSchema.optional(),
});
